import classNames from 'classnames'
import { Card } from '../Card'
import { Icon, IconName } from '../Icon'
import styles from './Alert.module.css'
import { AlertKind, AlertProps } from './types'

const IconMap: Record<AlertKind, IconName> = {
  success: 'checkCircle',
  warning: 'alertTriangle',
  error: 'alertCircle',
  info: 'alertInfo',
}

function Alert({ kind, global = false, size = 'medium', icon = false, className, style, children }: AlertProps) {
  const role = kind === 'error' ? 'alert' : 'status'
  return (
    <Card
      size={size}
      style={style}
      className={classNames(styles.alert, className, kind && styles[`kind-${kind}`], {
        [styles.global!]: global,
        [styles.small!]: size === 'small',
      })}
      role={role}
    >
      {icon && (
        <div className={classNames(styles[`icon-${kind}`], styles.iconContainer)}>
          {/* The color from the container is inherited from the container parent. */}

          <Icon name={IconMap[kind]} size={size === 'small' ? '200' : '300'} className={styles.icon} title={kind} />
        </div>
      )}
      <div>{children}</div>
    </Card>
  )
}

export default Alert
